import React from "react";
import {Tooltip, IconButton} from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    iconButton: {
        padding: 1,
        fontSize: 1,
        alignItems: "center"
    },
    helpIcon: {
        color: "black",
        fontSize: "larger"
    }
});

type HelpIconButtonProps = {
    message: string
}

/**
 * This is a re-usable Component. Provides a help icon button with tooltip
 */
const HelpIconButton: React.FunctionComponent<HelpIconButtonProps> = (props: HelpIconButtonProps) => {
    const styles = useStyles();

    return (
        <Tooltip title={props.message} placement="bottom-end">
            <span>
                <IconButton className={styles.iconButton}>
                    <HelpIcon className={styles.helpIcon} />
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default HelpIconButton;
